module.exports = __webpack_public_path__ + "static/media/low_shelf.d1ba8ac0.png";